import { render, staticRenderFns } from "./ViAdmissionSchoolAdmin.vue?vue&type=template&id=21f2f024"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports